// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xg-1";
export var printerIcon = "_xg-0";